import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { take } from "rxjs/operators";
import { clientConfig } from "../../shared/constant/app.constant";
import { NavButton } from "../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { CopyHelpers } from "../../shared/helpers/copy.helpers";
import { OrderItemDetailsComponent } from "../../shared/components/order-details/order-item-details.component";

@Component({
  selector: "return-item",
  templateUrl: "./return-item.component.html",
  styleUrls: ["./return-item.component.scss"],
})
export class ReturnItemComponent {
  @ViewChild(OrderItemDetailsComponent, { static: false }) childcomp: OrderItemDetailsComponent;

  emptyBasket: boolean;
  refundTotal: any = 0;
  refundDeductionRate: any = null;
  refundDeductionTotal: any = 0;
  refundedProducts: any;
  currency: any;
  showingDetails = false;
  ItemCardDetails: any[];
  details: any;
  selection: any;
  show: boolean;
  showdata: boolean;
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL
  };
  backBtnUrl = {
    routeUrl: "",
  };
  nextButton: NavButton = {
    buttonText: "continueButton",
    cssClass: "next-btn",
    isDisable: true,
  };
  orderData: any;
  showError: any = {
    show: false,
  };
  showRefund: boolean = clientConfig.SHOW_REFUND === "True";
  
  constructor(private router: Router, private appFlowService: AppFlowService, private store: Store<AppState>) {
    const route = this.appFlowService.findRouteFromSequence("itemselection");
    this.appFlowService.activeStepId = 1;
    this.nextButton.routeUrl = `/m/${route.next}`;
    this.backBtnUrl.routeUrl = `/m/${route.back}`;
    this.store.pipe(select("orderData")).subscribe((order) => {
      this.orderData = CopyHelpers.deepCopy(order);
    });

    this.store.pipe(select("returnOrder")).subscribe((returnOrder) => {
      if (returnOrder.items.length) {
        if (this.orderData.orders.length) {
          const order = this.orderData.orders.find((o) => o.orderNumber === returnOrder.orderNumber);

          if (order) {
            this.currency = order.orderLines[0].currency; //The currency of the first orderline item
            this.refundDeductionRate = order.deductionRate;
            order.orderLines = order.orderLines.map((item) => {
              const returnItem = returnOrder.items.find((i) => i.internalIdentifier === item.internalIdentifier);
              if (returnItem) return returnItem;
              return item;
            });
          }
        }

        this.orderData = CopyHelpers.deepCopy(this.orderData);
      } else {
        this.nextButton.isDisable = true;
      }
    });
  }

  showDetails() {
    this.showingDetails = !this.showingDetails;
  }

  navigate() {
    const route = this.appFlowService.findRouteFromSequence("itemselection");
    let order: any;
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        order = ro;
      });
    if (this.validate(order)) {
      this.router.navigate([`/m/${route.next}`]);
    }
  }

  calculateRefund(emittedOrderData: any) {
    const order = emittedOrderData;
    this.emptyBasket = true;
    this.refundTotal = 0;

    order.orders[0].orderLines.forEach((element) => {
      if (element.returnQuantity !== null && element.returnQuantity !== undefined && element.active) {
        this.refundTotal += element.unitPrice * element.returnQuantity;
        this.emptyBasket = false;
      }
    });
    this.refundedProducts = order.orders[0].orderLines;
    this.refundDeductionTotal = Math.fround(this.refundTotal * this.refundDeductionRate * 100);
    this.refundDeductionTotal = this.refundDeductionTotal / 100;
  }

  validate(returnOrder) {
    this.childcomp.status = true;
    let isValid = false;
    if (returnOrder.items && returnOrder.items.length) {
      //test all the itmes from returnOrder is valid
      // if not fill error in orderData to show on UI
      if (this.orderData.orders.length) {
        const order = this.orderData.orders.find((o) => o.orderNumber === returnOrder.orderNumber);
        if (order) {
          let isAllItemsValid = true;
          order.orderLines.forEach((orderLine) => {
            let thisItemValid = true;

            const item = returnOrder.items.find((i) => i.internalIdentifier === orderLine.internalIdentifier);
            //let invalidProps = [];
            if (item) {
              if (!orderLine.reasonForReturn || orderLine.reasonForReturn === "") {
                thisItemValid = false;
                //   invalidProps.push("reasonForReturn");
              }
              if (!orderLine.returnQuantity || orderLine.returnQuantity < 1) {
                thisItemValid = false;
                //   invalidProps.push("returnQuantity");
              }
            }

            if (!thisItemValid) {
              isAllItemsValid = false;
            }
            // orderLine.invalidProps = invalidProps;
          });

          this.orderData = CopyHelpers.deepCopy(this.orderData);

          if (!isAllItemsValid) {
            this.showError = {
              show: true,
              message: "missingReturnInformation",
            };
            this.childcomp.validateReturnOrderData();
          } else {
            isValid = true;
          }
        }
      }
    } else {
      this.showError = {
        show: true,
        message: "noItemSelected",
      };
      this.childcomp.validateReturnOrderData();
    }

    return isValid;
  }
}
